<app-search></app-search>
<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color">
            <h1>LISTA DE UBICACIÓN</h1>
        </div>
        <br />
        <!-- <div>
            <button id="" class="primary-button" (click)="create()">
                <span class="button-content">
                    <mat-icon>add_circle</mat-icon>Agregar nuevo
                </span>
            </button>
        </div> -->
        <br />
        <section class="table-container mat-elevation-z2" tabindex="0">
            <div class="table-adjustable">
                <table
                    mat-table
                    [dataSource]="
                        (asyncLocation | async)?.results ?? []
                            | paginate
                                : {
                                      id: 'server',
                                      itemsPerPage: limit,
                                      currentPage: page,
                                      totalItems: total,
                                  }
                    "
                >
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let location">
                            <div class="action-buttons">
                                <a
                                    (click)="updateLocation(location)"
                                    class="icon-button"
                                >
                                    <span class="material-symbols-outlined"
                                        ><mat-icon>edit</mat-icon></span
                                    >
                                </a>
                                <a
                                    (click)="eliminate(location)"
                                    appOnlysuperuser="/location"
                                    class="icon-button"
                                >
                                    <span class="material-symbols-outlined"
                                        ><mat-icon>delete</mat-icon></span
                                    >
                                </a>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="countryCode">
                        <th mat-header-cell *matHeaderCellDef>
                            Código de país
                        </th>
                        <td mat-cell *matCellDef="let location">
                            {{ location.countryCode }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="country">
                        <th mat-header-cell *matHeaderCellDef>País</th>
                        <td mat-cell *matCellDef="let location">
                            {{ location.country }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="departmentCode">
                        <th mat-header-cell *matHeaderCellDef>
                            Código de departamento
                        </th>
                        <td mat-cell *matCellDef="let location">
                            {{ location.departmentCode }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="department">
                        <th mat-header-cell *matHeaderCellDef>Departamento</th>
                        <td mat-cell *matCellDef="let location">
                            {{ location.department }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="cityCode">
                        <th mat-header-cell *matHeaderCellDef>
                            Código de ciudad
                        </th>
                        <td mat-cell *matCellDef="let location">
                            {{ location.cityCode }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="city">
                        <th mat-header-cell *matHeaderCellDef>Ciudad</th>
                        <td mat-cell *matCellDef="let location">
                            {{ location.city }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="geoRef">
                        <th mat-header-cell *matHeaderCellDef>
                            Georreferenciación
                        </th>
                        <td mat-cell *matCellDef="let location">
                            <a
                                class="enlace"
                                href="https://maps.google.com/?q={{
                                    location.geoRef?.latitude
                                }},{{ location.geoRef?.longitude }}"
                                target="_blank"
                            >
                                {{ location.geoRef?.latitude }},
                                {{ location.geoRef?.longitude }}
                            </a>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: showColumns"
                        class="highlight-row"
                    ></tr>
                </table>
            </div>
        </section>
        <pagination-controls
            (pageChange)="fetchLocation($event)"
            previousLabel="Anterior"
            nextLabel="Siguiente"
            id="server"
        ></pagination-controls>
    </div>
</div>
